<div class="card-text" [formGroup]="form">
    <bcu-date-picker-multiselect name="daysDates" formControlName="daysDates" [readonly]="readonly" [isRequired]="!readonly"></bcu-date-picker-multiselect>
</div>

